import { Risk_Trend } from "@phcglobal/connect-query"
import type { IconSize } from "../../icons/IconSize"
import SvgSlightDown from "../../icons/RiskArrows/Decreasing"
import SvgSlightUp from "../../icons/RiskArrows/Increasing"
import SvgSteady from "../../icons/RiskArrows/Persistant"

interface TrendProps {
  trend?: Risk_Trend
  color: string
  size?: IconSize
}

export const TrendSVG: React.FC<TrendProps> = ({ trend, color, size }) => {
  switch (trend) {
    case Risk_Trend.DECREASING:
    case Risk_Trend.DECREASING_RAPIDLY:
      return <SvgSlightDown size={size} fill={color} />
    case Risk_Trend.INCREASING:
    case Risk_Trend.INCREASING_RAPIDLY:
      return <SvgSlightUp size={size} fill={color} />
    case Risk_Trend.PERSISTENT:
      return <SvgSteady size={size} fill={color} />
    case Risk_Trend.UNSPECIFIED:
    case undefined:
    default:
      return null
  }
}
